import request from '@/libs/request'

// 种植 气象设备 列表
export function plantDeviceMeteorologyListApi (data = {}) {
  return request({
    url: `plant/plantDevice/meteorology`,
    method: 'get',
    params: data
  })
}

// 种植 土壤设备 列表
export function plantDeviceSoilListApi (data = {}) {
  return request({
    url: `plant/plantDevice/soil`,
    method: 'get',
    params: data
  })
}

// 种植 虫情设备 列表
export function plantDevicePestListApi (data = {}) {
  return request({
    url: `plant/plantDevice/pest`,
    method: 'get',
    params: data
  })
}

// 种植 苗青设备 列表
export function plantDeviceCropListApi (data = {}) {
  return request({
    url: `plant/plantDevice/crop`,
    method: 'get',
    params: data
  })
}

// 种植 监控设备 列表
export function plantDeviceMonitoringListApi (data = {}) {
  return request({
    url: `plant/plantDevice/monitoring`,
    method: 'get',
    params: data
  })
}


